import {request} from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";

export async function getCodebooks() {
    return await request('api/data/all', {}, HttpMethod.GET);
}